// App.js
import React, { useEffect } from "react";
import Home from "../src/Pages/Home";
import AboutUsSection from './components/Home/AboutusSection';
import ACE from './components/Home/ACE';
import VoiceOFBeneficiars from './components/Home/VoiceOfBenificiars';
import Goals from './components/Home/Goals';
import FarmerRegisterSection from './components/Home/RegisterAsIntrepuener';
import PartnersSection from './components/Home/PartnersSection';

function App() {
  useEffect(() => {
    const user = localStorage.getItem("user");

    if (!user) {
      localStorage.setItem("user", JSON.stringify({
        email: "test@farm.com",
        password: "123456"
      }));
    }
  }, []);

  return (
    <div className='font-inter lg:-mt-2 xl:-mt-8'>
      <Home />
      <AboutUsSection />
      <ACE />
      <VoiceOFBeneficiars />
      <Goals />
      <FarmerRegisterSection />
      <PartnersSection />
    </div>
  );
}

export default App;
